module.exports = __webpack_public_path__ + "img/n-excretion.aef53612.svg";